"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";

const IMAGE_SRC = "/image/new-version/ValueAddedSolutions/surface-finishing/what-is-surface-finishing.webp";

const ITEMS = [
	{ keyPrefix: "essentialItem1" },
	{ keyPrefix: "essentialItem2" },
	{ keyPrefix: "essentialItem3" },
	{ keyPrefix: "essentialItem4" },
] as const;

export default function SurfaceFinishingEssential() {
	const t = useTranslations("new-surface-finishing");

	return (
		<section className="bg-white py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<div className="grid items-center gap-8 lg:grid-cols-[1.05fr_1fr] lg:gap-10">
					<div>
						<header className="mb-6 sm:mb-8">
							<h2 className="mb-3 text-2xl font-bold leading-tight text-black sm:mb-4 sm:text-[30px] md:text-4xl">
								{t("essentialTitle")}
							</h2>
							<p className="text-sm leading-relaxed text-black md:text-base">{t("essentialDesc")}</p>
						</header>

						<div className="space-y-5">
							{ITEMS.map((item) => (
								<div key={item.keyPrefix}>
									<h3 className="mb-2 text-base font-bold text-black sm:text-lg">
										{t(`${item.keyPrefix}Title`)}
									</h3>
									<p className="text-sm leading-relaxed text-black md:text-base">
										{t(`${item.keyPrefix}Desc`)}
									</p>
								</div>
							))}
						</div>
					</div>

					<div className="relative aspect-[4/3.3] w-full self-end overflow-hidden bg-[#f5f7fa]">
						<Image
							src={IMAGE_SRC}
							alt={t("essentialImageAlt")}
							fill
							className="object-cover"
							sizes="(max-width: 1024px) 100vw, 50vw"
						/>
					</div>
				</div>
			</div>
		</section>
	);
}
